import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { copyText } from '../lib/clipboard';
import { IconCheck, IconCopy } from './Icons';

export default function CopyButton({ value, label = '複製', className }: { value: string; label?: string; className?: string }) {
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!done) return;
    const t = setTimeout(() => setDone(false), 1800);
    return () => clearTimeout(t);
  }, [done]);

  return (
    <button
      type="button"
      onClick={async () => { if (await copyText(value)) setDone(true); }}
      className={clsx(
        'inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-full border text-[13px] font-bold whitespace-nowrap transition-colors',
        done ? 'border-ok-dot bg-ok-soft text-ok' : 'border-line bg-white text-ink active:bg-soft',
        className,
      )}
    >
      {done ? <IconCheck size={15} /> : <IconCopy size={15} />}
      {done ? '已複製' : label}
    </button>
  );
}
